import * as React from 'react';
import {
  DEFAULT_TILES_PER_ROW,
  DEFAULT_TILE_WIDTH,
  WishlistHelperContext,
  ImpressionTrackerProvider,
  ImpressionTracker,
  Clickout,
  LoadMoreGridSection,
} from '@packages/shared';
import { Product, DeviceType, ClickoutSegment } from '@packages/common';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';
import { Flex, Box } from '@packages/ui';

import { ProductTile, formatNumberWithLocale } from '../../../ProductTile';

const APP_TLD = getPublicRuntimeConfig('APP_TLD');

interface CmsProductGridProps {
  hits: Product[];
  handleUpdatePage: VoidFunction;
  totalResultsAvailable: number;
  showLoadmore: boolean;
  categoryId: string;
  deviceType: DeviceType;
}

export const CmsProductGrid: React.FC<CmsProductGridProps> = ({
  hits = [],
  handleUpdatePage,
  totalResultsAvailable = hits.length,
  showLoadmore,
  categoryId,
  deviceType,
}) => {
  const { wishlistHelper } = React.useContext(WishlistHelperContext);
  const formattedTotalHitsCount = formatNumberWithLocale(totalResultsAvailable, APP_TLD);
  return (
    <ImpressionTrackerProvider
      impressionMetadata={{
        categoryId: categoryId ? categoryId : '0',
        deviceType: deviceType,
        segment: ClickoutSegment.CONTENT,
        sortedList: false, //? recheck
      }}
    >
      {
        <Flex flexWrap="wrap" pt={[3, 3, 5]}>
          {hits.map((product, index) => (
            <Box p={[1, 1, 2, 2]} width={DEFAULT_TILE_WIDTH} key={product.objectID}>
              <ImpressionTracker product={product} index={index}>
                <ProductTile
                  product={product}
                  index={index}
                  isLocallyFiltered={false}
                  wishlistHelper={wishlistHelper}
                  sorted={false}
                  Clickout={Clickout}
                />
              </ImpressionTracker>
            </Box>
          ))}
          {showLoadmore && hits.length < totalResultsAvailable && (
            <Box width={[1]}>
              <LoadMoreGridSection
                gridColsCount={DEFAULT_TILES_PER_ROW as number[]}
                totalCount={formattedTotalHitsCount}
                itemsCount={hits.length}
                onClick={handleUpdatePage}
              ></LoadMoreGridSection>
            </Box>
          )}
        </Flex>
      }
    </ImpressionTrackerProvider>
  );
};
